<template>
  <div class="card mb-4" v-if="link">
    <div class="card-body">
      <div class="row">
        <div class="col mr-auto d-flex">
          <h4 class="mb-0 mt-auto">{{ 'quote_link_sent_to_customer' | t }}</h4>
        </div>
        <div class="col-auto">
          <a class="btn btn-primary" :href="link" target="_blank">{{ 'open_in_new_tab' | t }}</a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <span>{{ link }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-check

export default {
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  computed: {
    /** @return {?String} */
    link() {
      if (!this.customer.quote || !this.customer.quote.quote_link) {
        return null;
      }

      return this.customer.quote.quote_link;
    }
  }
};
</script>
